import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { AnalyticsInsightReportFeedbackSchema_ } from "./analytics-insight-report-feedback-schema";

const AnalyticsInsightReportSchema_ = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  title: z.string(),
  description: z.string(),
  body: z.string(),
  createdAt: z.date(),
  analysisStartDate: z.date(),
  analysisEndDate: z.date(),
  analysisTeamId: zExt.objectId(),
  feedback: z.array(AnalyticsInsightReportFeedbackSchema_).optional(),
});

export interface AnalyticsInsightReport
  extends z.infer<typeof AnalyticsInsightReportSchema_> {}

export const getAnalyticsInsightReports = {
  name: "getAnalyticsInsightReports" as const,
  input: z.void(),
  output: z.array(AnalyticsInsightReportSchema_),
};
